<component class="table--row block" :is="routerLinkTo ? 'router-link' : 'div'" :to="routerLinkTo" @click.stop="onRowClick($event)"><slot></slot></component>